import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/ui';
import { DIGITAL_PRODUCT_API } from 'modules/digital-product/api';
import { DigitalProductSourceEnum } from 'modules/digital-product/enums/digital-product-source-enum';
import { DigitalProductInterface } from 'modules/digital-product/types/digital-product-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { digitalProductDependencies } from '../constants/digital-product-dependencies';
export function useDigitalProductsList(currency, source) {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const t1 = `${DIGITAL_PRODUCT_API}/list?currency=${currency}&source=${source}`;
  let t2;
  if ($[1] !== t1) {
    t2 = [t1, ...digitalProductDependencies];
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: digitalProductList,
    mutate
  } = useControlledSwr(t2, fetcher, t3, !!user);
  let t4;
  if ($[4] !== digitalProductList || $[5] !== mutate) {
    t4 = {
      digitalProductList,
      mutate
    };
    $[4] = digitalProductList;
    $[5] = mutate;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}